import React from 'react';

type Tone = 'green' | 'amber' | 'red' | 'blue' | 'slate';

const StatusChip: React.FC<{ label: string; tone?: Tone }> = ({ label, tone = 'slate' }) => (
  <span className={`chip chip-${tone}`}>
    <span className="chip-dot" />
    {label}
  </span>
);

export default StatusChip;
